import { render, staticRenderFns } from "./ClientViewOfferHistory.vue?vue&type=template&id=7d4cff28&scoped=true&"
import script from "./ClientViewOfferHistory.vue?vue&type=script&lang=js&"
export * from "./ClientViewOfferHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4cff28",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VIcon,VRow,VSheet})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d4cff28')) {
      api.createRecord('7d4cff28', component.options)
    } else {
      api.reload('7d4cff28', component.options)
    }
    module.hot.accept("./ClientViewOfferHistory.vue?vue&type=template&id=7d4cff28&scoped=true&", function () {
      api.rerender('7d4cff28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TravelService/ClientViewOfferHistory.vue"
export default component.exports